export default __webpack_public_path__ + "static/media/gallery-image-9-full.bc532235.jpg";